/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SkuUpdateBarcodeItem } from './SkuUpdateBarcodeItem';
import {
    SkuUpdateBarcodeItemFromJSON,
    SkuUpdateBarcodeItemFromJSONTyped,
    SkuUpdateBarcodeItemToJSON,
    SkuUpdateBarcodeItemToJSONTyped,
} from './SkuUpdateBarcodeItem';

/**
 * 
 * @export
 * @interface SkuUpdateReqVo
 */
export interface SkuUpdateReqVo {
    /**
     * SKU ID
     * @type {number}
     * @memberof SkuUpdateReqVo
     */
    skuId: number;
    /**
     * SKU编码；仅管理端可改，留空或与原值相同表示不修改，未删除商品范围内全局唯一
     * @type {string}
     * @memberof SkuUpdateReqVo
     */
    skuCode?: string;
    /**
     * 重量(kg)
     * @type {number}
     * @memberof SkuUpdateReqVo
     */
    wtKg?: number;
    /**
     * 体积(立方米)
     * @type {number}
     * @memberof SkuUpdateReqVo
     */
    cbm?: number;
    /**
     * 宽度(cm)
     * @type {number}
     * @memberof SkuUpdateReqVo
     */
    width?: number;
    /**
     * 长度(cm)
     * @type {number}
     * @memberof SkuUpdateReqVo
     */
    length?: number;
    /**
     * 高度(cm)
     * @type {number}
     * @memberof SkuUpdateReqVo
     */
    height?: number;
    /**
     * Logo图片URL
     * @type {string}
     * @memberof SkuUpdateReqVo
     */
    logoImgUrl?: string;
    /**
     * 
     * @type {Array<SkuUpdateBarcodeItem>}
     * @memberof SkuUpdateReqVo
     */
    barcodes?: Array<SkuUpdateBarcodeItem>;
}

/**
 * Check if a given object implements the SkuUpdateReqVo interface.
 */
export function instanceOfSkuUpdateReqVo(value: object): value is SkuUpdateReqVo {
    if (!('skuId' in value) || value['skuId'] === undefined) return false;
    return true;
}

export function SkuUpdateReqVoFromJSON(json: any): SkuUpdateReqVo {
    return SkuUpdateReqVoFromJSONTyped(json, false);
}

export function SkuUpdateReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkuUpdateReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'skuId': json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'wtKg': json['wtKg'] == null ? undefined : json['wtKg'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
        'width': json['width'] == null ? undefined : json['width'],
        'length': json['length'] == null ? undefined : json['length'],
        'height': json['height'] == null ? undefined : json['height'],
        'logoImgUrl': json['logoImgUrl'] == null ? undefined : json['logoImgUrl'],
        'barcodes': json['barcodes'] == null ? undefined : ((json['barcodes'] as Array<any>).map(SkuUpdateBarcodeItemFromJSON)),
    };
}

export function SkuUpdateReqVoToJSON(json: any): SkuUpdateReqVo {
    return SkuUpdateReqVoToJSONTyped(json, false);
}

export function SkuUpdateReqVoToJSONTyped(value?: SkuUpdateReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'wtKg': value['wtKg'],
        'cbm': value['cbm'],
        'width': value['width'],
        'length': value['length'],
        'height': value['height'],
        'logoImgUrl': value['logoImgUrl'],
        'barcodes': value['barcodes'] == null ? undefined : ((value['barcodes'] as Array<any>).map(SkuUpdateBarcodeItemToJSON)),
    };
}

